<template>
	<div class="person_select">
		<van-field autocomplete="off" required :value="personName" @input="$emit('update:personName',$event)" :placeholder="$en('请选择员工')" :label="$en(label)" :label-width="labelWidth" readonly @click.stop="!isReadonly&&openPersonSelect()" maxlength="100">
			<template #label v-if="isAdd||isDelete">
				{{$en(label)}}
			</template>
			<template #button v-if="isAdd||isDelete">
				<van-icon v-if="isDelete" name="minus"class="interest_van_icon" color="#4D9EFF" @click.stop="$emit('delete')"/>
				<van-icon v-else-if="isAdd" name="plus"class="interest_van_icon" color="#4D9EFF" @click.stop="$emit('add')"/>
			</template>
		</van-field>
		<!-- 移动端：全屏选择面板 -->
		<div v-show="personSelectShow" class="person_select_plan body_show_destroy person_select_mobile" ref="person_select_plan">
			<van-nav-bar :title="$en('选择员工')" :left-text="$en('关闭')" left-arrow @click-left="closeClick"/>
			<van-field v-model="queryKeyWord" :placeholder="$en('模糊搜索')" left-icon="search" @input="debounceQuerySelect()"/>
			<div style="width:100%;max-height:calc(100% - 90px);overflow: auto;">
				<table class="person_select_list">
					<tr v-for="(item,index) in personList" @click="personClick(index,item)">
						<td width="10%">
							<div class="cell center">
								<van-checkbox v-model="item.isSelect"/>
							</div>
						</td>
						<td width="20%">
							<div class="cell">
								{{item.OGU_NAME}}
							</div>
						</td>
						<td width="20%">
							<div class="cell">
								{{item.OGU_USERID}}
							</div>
						</td>
						<td>
							<div class="cell">
								{{item.OGU_RANK_NAME}}
							</div>
						</td>
					</tr>
					<tr style="color:rgb(153, 153, 153);" v-if="!personList||personList.length==0">
						<td>
							<div class="cell center">
								{{$en('暂无数据，请重新输入查询条件')}}
							</div>
						</td>
					</tr>
				</table>
			</div>
		</div>
		<!-- PC端：对话框选择面板 -->
		<el-dialog :title="$en('选择员工')" :visible.sync="dialogVisible" width="50%" append-to-body custom-class="person_select_dialog" :close-on-click-modal="false" @close="closeClick">
			<el-input v-model="queryKeyWord" :placeholder="$en('模糊搜索')" clearable @input="debounceQuerySelect()" style="margin-bottom:16px;"/>
			<div class="person_select_dialog_list">
				<table class="person_select_list person_select_list_pc">
					<thead>
						<tr>
							<th width="40px"></th>
							<th width="80px">{{$en('姓名')}}</th>
							<th width="80px">{{$en('工号')}}</th>
							<th>{{$en('职位')}}</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item,index) in personList" @click="personClick(index,item)" class="person_select_row_pc">
							<td width="40px">
								<van-checkbox v-model="item.isSelect"/>
							</td>
							<td width="80px">{{item.OGU_NAME}}</td>
							<td width="80px">{{item.OGU_USERID}}</td>
							<td>{{item.OGU_RANK_NAME}}</td>
						</tr>
						<tr v-if="!personList||personList.length==0" class="person_select_empty">
							<td colspan="4" style="text-align:center;color:#999;padding:30px 0;">
								{{$en('暂无数据，请重新输入查询条件')}}
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</el-dialog>
	</div>
</template>
<script>
export default {
	data(){
		return {
			personSelectShow:false,
			queryKeyWord:'',
			personList:[],
			queryTime:0,
			curSelect:{},
			isPC: window.innerWidth >= 769
		}
	},
	inject:{
		vanForm:{
			default:''
		}
	},
	props:{
		labelWidth:{
			type:Number,
			default(){
				return 90
			}
		},
		readonly:{
			type:Boolean,
			default(){
				return false
			}
		},
		// 是否包含外部顾问
		allPerson:{
			type:Boolean,
			default(){
				return false
			}
		},
		isAdd:{
			type:Boolean,
			default(){
				return false
			}
		},
		isDelete:{
			type:Boolean,
			default(){
				return false
			}
		},
		value:{
			type:String,
			default(){
				return ''
			}
		},
		personName:{
			type:String,
			default(){
				return ''
			}
		},
		label:{
			type:String,
			default(){
				return '姓名'
			}
		},
		// 目前只实现了单选
		multiple:{
			type:Boolean,
			default(){
				return false
			}
		}
	},
	watch:{
		value:{
			deep:true,
			immediate:true,
			async handler(val,old){
				let isInit = val&&!this.curSelect.OGU_GUID
				await this.querySelect();
				if(isInit){
					this.$emit('update:personName',this.curSelect.OGU_NAME)
					this.$emit('select',this.curSelect,true)
				}
			}
		},
	},
	computed:{
		isReadonly(){
			return this.readonly || (this.vanForm || {}).readonly;
		},
		// PC端dialog只有在isPC时才可见，避免移动端误触发弹框
		dialogVisible:{
			get(){
				return this.isPC && this.personSelectShow
			},
			set(val){
				if(!val){
					this.personSelectShow = false
				}
			}
		}
	},
	created(){
		window.addEventListener('popstate',()=>{
			if(this.personSelectShow){
				history.pushState(null,null,document.URL)
				this.personSelectShow = false
			}
		})
	},
	beforeDestroy(){
		if(this.personSelectShow){
			this.personSelectShow = false
		}
	},
	methods:{
		closeClick(){
			this.personSelectShow=false
		},
		debounceQuerySelect(){
			let curTime = new Date().getTime()
			setTimeout(()=>{
				console.log(curTime,this.queryTime)
				if(curTime==this.queryTime){
					this.querySelect()
				}
			},500)
			this.queryTime = curTime
		},
		async querySelect(){
			if(!this.queryKeyWord&&!this.value){
				this.personList = []
				return
			}
			await this.$http.get('/api/orgPerson/v0.1/orgPerson/getUserList',{
				params:{
					pageSize:100,
					keyWord:this.queryKeyWord,
					oguGuids:this.queryKeyWord?null:this.value,
					userType:this.allPerson?'':'1'
				}
			})
			.then(res=>{
				this.personList = res.data.list
				this.initDef()
			})
		},
		initDef(){
			if(this.value){
				this.personList.map(item=>{
					if(this.value.indexOf(item.OGU_GUID)>-1){
						item.isSelect = true
						this.curSelect = item
					}
				})
			}
		},
		getSelect(){
			return this.personList.filter(item=>{
				return item.isSelect
			})
		},
		openPersonSelect(){
			if(this.isPC){
				// PC端：直接显示 el-dialog
				this.personSelectShow = true
				this.querySelect()
			}else{
				// 移动端：全屏面板
				document.body.appendChild(this.$refs.person_select_plan);
				history.pushState(null,null,document.URL)
				this.personSelectShow = true
				this.querySelect()
			}
		},
		personClick(index,item){
			let curIsSelect = item.isSelect?false:true
			if(!this.multiple){
				let lastSelect = this.personList[index].isSelect?true:false
				if(!lastSelect){
					this.personList.map(itm=>{
						itm.isSelect = false
					})
				}
			}
			this.curSelect = curIsSelect?item:{}
			this.$set(this.personList[index],'isSelect',curIsSelect)
			this.$forceUpdate()
			this.$emit('input',this.getSelect().map(item=>{
				return item.OGU_GUID
			}).join(','))
			this.$emit('update:personName',this.curSelect.OGU_NAME)
			this.$emit('select',this.curSelect,false)
			setTimeout(()=>{
				this.closeClick()
			},300)
		}
	},
}
</script>
<style scoped lang="less">
	.interest_van_icon{
		font-weight: 800;
	}
	.person_select_plan{
		position:fixed;
		height:100%;
		width:100%;
		background:#dce7f9;
	}
	.person_select_list{
		border-collapse: collapse;
		width:100%;
	}
	.person_select_list tr td{
		min-width:10px !important;
		text-align: left;
		padding:12px 5px;
	}
	.person_select_list tr{
		border-bottom: 1px solid #fff;
	}
	.person_select_list .cell.center{
		justify-content: center;
		display: flex;
	}
	/* 移动端面板：单元格内容不换行，超出省略号 */
	.person_select_mobile .person_select_list .cell{
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	.person_select_mobile .person_select_list td{
		max-width: 0;
	}
	.person_select_list tr::after{
		border-top: 1px solid #fff;
	}
	/deep/ .van-cell__title{
		font-size: 16px;
		color: #333333;
		flex:unset;
		-webkit-box-flex:unset;
		-webkit-flex:unset;
	}
	/deep/ .van-field__control{
		font-size: 16px;
		color: #333333;
	}

	/* PC端对话框内列表 */
	.person_select_dialog_list{
		height: 500px;
		overflow-y: auto;
	}
	.person_select_list_pc{
		thead th{
			background-color: #f5f7fa;
			padding: 10px 8px;
			font-size: 18px;
			color: #666;
			font-weight: 600;
			text-align: left;
			border-bottom: 1px solid #ebeef5;
		}
		tbody td{
			padding: 10px 8px;
			font-size: 18px;
			color: #333;
		}
	}
	.person_select_row_pc{
		cursor: pointer;
		transition: background-color 0.15s;
		&:hover{
			background-color: #f5f7fa;
		}
	}
	.person_select_empty td{
		text-align: center !important;
	}

	/* PC端响应式：隐藏移动端全屏面板 */
	@media (min-width: 769px) {
		.person_select_mobile{
			display: none !important;
		}
		/deep/.el-input__inner{
			font-size: 18px;
		}
	}
	/* 移动端：隐藏PC端dialog中的内容（dialog本身通过isPC控制） */
	@media (max-width: 768px) {
		.person_select_dialog_list{
			display: none;
		}
	}
</style>

<style>
	/* PC端对话框样式（非scoped） */
	.person_select_dialog .el-dialog__header{
		border-bottom: 1px solid #ebeef5;
		padding-bottom: 16px;
	}
	.person_select_dialog .el-dialog__title{
		font-size: 18px;
		font-weight: 600;
	}
	.person_select_dialog .el-dialog__body{
		padding-top: 20px;
	}
</style>